import React from 'react';
import { DocsIcon, google } from 'assets';
import { useAppSelector } from 'state/hooks';

interface UploadedCVFile {
  name: string;
}

interface UploadedCVDisplayProps {
  files: UploadedCVFile[];
}

const UploadedCVDisplay: React.FC<UploadedCVDisplayProps> = ({ files }) => {
  const user = useAppSelector((state) => state.user);
  const { companyLogo } = user;
  return (
    <div className="flex flex-col gap-3 my-4 items-end">
      <div className='flex gap-2.5 items-start'>
        <div className='flex flex-col items-end gap-3'>
          {files.map((file, index) => (
            <div
              key={index}
              className="
            flex items-center justify-between gap-3 px-3 py-2 rounded-xl
            bg-[#1849A9] border border-gray-200 shadow-sm
            hover:shadow-md transition-shadow duration-150 w-fit
          "
            >
              <div className="flex items-center gap-2">
                <div
                  className="
                grid place-content-center w-[34px] h-[34px]
                bg-white border border-gray-200 rounded-full
              "
                >
                  <DocsIcon style={{ color: '#012169' }} />
                </div>

                <div className="flex flex-col">
                  <p className="text-sm font-medium text-white max-w-[200px] truncate">
                    {file.name}
                  </p>
                  <p className="text-xs text-[#D0D5DD]">Document</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {/* ✅ Show Google icon only for the first item */}
        {companyLogo ? (
          <img
            src={companyLogo}
            alt="Company Logo"
            className="w-[35px] h-[35px] min-w-[35px] min-h-[35px] object-contain md:w-[20px] md:h-[20px] mt-1 rounded-full border border-gray-300"
          />
        ) : (
          <img
            src={google}
            alt="Google Icon"
            className="w-[35px] h-[35px] min-w-[35px] min-h-[35px] object-contain md:w-[20px] md:h-[20px] mt-1 rounded-full border border-gray-300"
          />
        )}
      </div>
    </div>
  );
};

export { UploadedCVDisplay };
export type { UploadedCVFile };
